
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { BaseLayout } from '@/components/templates';
import { withUrql } from '@/config/graphql';
import { BACKEND_URLS } from '@/config/urls';
import { useRedirect } from '@/utils/hooks';
import { useCurrentUser } from '@/utils/hooks/useCurrentUser';
import { Heading } from '@chakra-ui/react';
import { Options } from '@contentful/rich-text-react-renderer';
import { BLOCKS, Document } from '@contentful/rich-text-types';
import { Node, TextualHero } from '@meritcircle/ui/components';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { GetServerSideProps, NextPage } from 'next';
import { RewardsDocument, RewardsQuery } from '@/client/graphql/rewards.generated';
import { canonicalUrl as getCanonicalUrl } from '@/utils/seo';
import { Seo } from '@/components/utils/seo/seo-component';
import RewardsSection from '@/components/features/rewards/rewards-section/rewards-section';
import { getUrqlServerClient } from '@/config/withUrql';
import { getOpenGraphProps } from '@/components/utils/seo/get-open-graph-props';
import { ClubWithRaffles } from '@/utils/api/teams/schemas';
const subtitleOptionsLoggedIn: Options = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node: Node, children: string) => (<Heading as="p" variant="glowing" size="xs" color="white">
        {children}
      </Heading>)
    }
};
type PageProps = {
    rewards: RewardsQuery;
    clubs: ClubWithRaffles[];
};
const Page: NextPage = ({ rewards, clubs }: PageProps) => {
    const currentUser = useCurrentUser();
    const { t } = useTranslation('rewards');
    // const levels = formatLevelsFromRewards(rewards, t);
    const { redirect } = useRedirect();
    const router = useRouter();
    const { title, subtitle, loggedUserSubtitle, linkedSeoTags, metaTitle, metaDescription, ogImage, noFollow, noIndex, keywords, } = rewards?.giveawayOverview || {};
    const subtitleDocument: Document = currentUser.isLoggedIn
        ? loggedUserSubtitle.json
        : subtitle.json;
    const subtitleOptions = currentUser.isLoggedIn ? subtitleOptionsLoggedIn : undefined;
    const canonicalUrl = getCanonicalUrl(router);
    return (<BaseLayout>
      <Seo title={linkedSeoTags?.title || metaTitle || t('meta.title')} description={linkedSeoTags?.description || metaDescription || t('meta.description')} nofollow={linkedSeoTags?.noFollow || noFollow} noindex={linkedSeoTags?.noIndex || noIndex} keywords={linkedSeoTags?.keywords || keywords} lastUpdate={`${new Date()}`} canonical={canonicalUrl} openGraph={getOpenGraphProps({
            title: linkedSeoTags?.title || metaTitle || t('meta.title'),
            description: linkedSeoTags?.description || metaDescription || t('meta.description'),
            url: canonicalUrl,
            image: ogImage
        })}/>
      <TextualHero title={title} subtitle={subtitleDocument} subtitleOptions={subtitleOptions} cta={!currentUser.isLoggedIn
            ? {
                label: t('common:navigation.register'),
                url: BACKEND_URLS.REGISTER,
                onClick: () => {
                    redirect(BACKEND_URLS.REGISTER, router.asPath);
                }
            }
            : undefined}/>

      <RewardsSection clubs={clubs}/>
    </BaseLayout>);
};
const getServerSideProps: GetServerSideProps<PageProps> = async (ctx) => {
    const { urqlClient } = getUrqlServerClient(ctx);
    console.log('Trying to get rewards page');
    const result = await urqlClient.query<RewardsQuery>(RewardsDocument).toPromise();
    const clubs = await fetch(`${process.env.NEXT_PUBLIC_BACKEND_BASE_KBOOM}/clubs/with-raffles`)
        .then(res => res.json() as Promise<{
        results: ClubWithRaffles[];
    }>)
        .then(data => data.results.filter(club => club.public).filter(club => club.raffles.length > 0));
    if (!clubs) {
        console.warn('👻 No clubs found');
    }
    console.log('Clubs', clubs);
    if (!result.data) {
        console.warn('👻 Rewards page missing');
        return {
            notFound: true
        };
    }
    return {
        props: { rewards: result.data, clubs: clubs || [] } as PageProps
    };
};
export default withUrql(Page);

    async function __Next_Translate__getServerSideProps__1973b3b2cc1__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/rewards/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1973b3b2cc1__ as getServerSideProps }
  